<div class="inspection-dashboard-list">
  <nb-card>
    <nb-card-header>
      <span>Begehungen</span>
      <div class="spacer"></div>
      <nb-button-group (valueChange)="mode.set($event[0])">
        <button nbButtonToggle value="overdue" [pressed]="mode() === 'overdue'">Überfällig</button>
        <button nbButtonToggle value="upcoming" [pressed]="mode() === 'upcoming'">Kommend</button>
      </nb-button-group>
    </nb-card-header>
    @if (mode() === 'overdue') {
    <wr-table [rows]="overdueInspections()"
              [loading]="overdueLoading()">
      <ng-template column
                   let-dueState
                   [of]="overdueInspections()"
                   header="Gebäude">
        <wr-building-badge [building]="dueState.building"></wr-building-badge>
      </ng-template>
      <ng-template column
                   let-dueState
                   [of]="overdueInspections()"
                   header="Hausverwaltung">
        <wr-tenant-badge [tenant]="dueState.ownerTenant"></wr-tenant-badge>
      </ng-template>
      <ng-template column
                   let-dueState
                   [of]="overdueInspections()"
                   header="Begehungstyp"
                   shrink>
        @if (dueState.normType === 'NORM_1300') {
          B1300
        } @else if (dueState.normType === 'NORM_1301') {
          B1301
        } @else {
          –
        }
      </ng-template>
      <ng-template column
                   let-dueState
                   [of]="overdueInspections()"
                   header="Überfällig seit"
                   shrink>
        <span class="overdue-date">{{ dueState.dueDate | date: 'dd.MM.yyyy' }}</span>
      </ng-template>
      <wr-table-pagination [totalRows]="overdueCount()"
                           [(pageSize)]="overduePageSize"
                           [(page)]="overduePage"></wr-table-pagination>
    </wr-table>
    }
    @if (mode() === 'upcoming') {
    <wr-table [rows]="upcomingInspections()"
              [loading]="upcomingLoading()"
              [(sort)]="upcomingSort"
              [rowLink]="getInspectionLink">
      <ng-template column
                   let-inspection
                   [of]="upcomingInspections()"
                   header="Datum"
                   shrink
                   sort="fromTimestamp">
        {{ inspection.fromTimestamp | date: 'dd.MM.yyyy' }}
      </ng-template>
      <ng-template column
                   let-inspection
                   [of]="upcomingInspections()"
                   header="Gebäude">
        <wr-building-badge [building]="inspection.building"></wr-building-badge>
      </ng-template>
      <ng-template column
                   let-inspection
                   [of]="upcomingInspections()"
                   header="Hausverwaltung">
        <wr-tenant-badge [tenant]="inspection.ownerTenant"></wr-tenant-badge>
      </ng-template>
      <ng-template column
                   let-inspection
                   [of]="upcomingInspections()"
                   header="Techniker*in">
        <wr-user-badge [user]="inspection.technician"></wr-user-badge>
      </ng-template>
      <ng-template column
                   let-inspection
                   [of]="upcomingInspections()"
                   header="Sachbearbeiter*in">
        @if (inspection.clerk) {
          <wr-user-badge [user]="inspection.clerk"></wr-user-badge>
        }
      </ng-template>
      <wr-table-pagination [totalRows]="upcomingCount()"
                           [(pageSize)]="upcomingPageSize"
                           [(page)]="upcomingPage"></wr-table-pagination>
    </wr-table>
    }
  </nb-card>
</div>
